import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import classes from '../../../index.module.scss'
import { BankTransfer } from './paymentMethod/BankTransfer'
import { Card } from './paymentMethod/Card'
import { PackageMethod } from './paymentMethod/PackageMethod'

export const PaymentMethod = ({
  paymentMethodList,
  paymentMethod,
  setPaymentMethod,
  currencyType,
  setCurrencyType,
  bankTransferType,
  setBankTransferType,
  isScreening,
  orderId,
  setDisablePackage,
  isShowInvalidPackage,
}) => {
  return (
    <Element
      style={{
        backgroundColor: '#FFFFFF',
        height: paymentMethod === paymentMethodList.PACKAGE ? '100%' : 'auto',
      }}
      className={classes.invoiceInfoContainer}
    >
      <Element className="fw600" style={{ fontSize: 14 }}>
        <Translate value="userManagement.paymentMethod.PAYMENT_METHOD" />
      </Element>
      <div className="dFlex mt1">
        {Object.values(paymentMethodList).map((key, index) => {
          const isActive = key === paymentMethod
          const itemKey = Object.keys(paymentMethodList)[index]
          return (
            <Element
              key={key}
              className={classes.paymentTab}
              style={{
                border: isActive ? '1px solid #2C73E8' : undefined,
                color: isActive ? '#2C73E8' : undefined,
                fontSize: 14,
              }}
              onClick={() => setPaymentMethod(key)}
            >
              <Translate value={`userManagement.paymentMethod.${itemKey}`} />
              {isActive && (
                <Element
                  className={classes.triangle}
                  style={{
                    borderColor: 'transparent #2C73E8 transparent transparent',
                  }}
                />
              )}
            </Element>
          )
        })}
      </div>
      {paymentMethod === paymentMethodList.PACKAGE && (
        <PackageMethod
          isScreening={isScreening}
          orderId={orderId}
          setDisablePackage={setDisablePackage}
          isShowInvalidPackage={isShowInvalidPackage}
        />
      )}
      {paymentMethod === paymentMethodList.CARD && (
        <Card
          bankTransferType={bankTransferType}
          setBankTransferType={setBankTransferType}
        />
      )}
      {paymentMethod === paymentMethodList.BANK_TRANSFERS && (
        <BankTransfer
          currencyType={currencyType}
          setCurrencyType={setCurrencyType}
        />
      )}
    </Element>
  )
}
